import { footerChannels, links, petitionLabel } from "../content";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer__inner">
        {/* A plain link, not a <button> wrapping an <a> — an anchor inside a
            button is invalid markup and breaks keyboard and middle-click use. */}
        <a
          className="footer__petition"
          href={links.petition}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`${petitionLabel} (opens in new tab)`}
        >
          {petitionLabel}
        </a>

        <ul className="footer__channels">
          {footerChannels.map((channel) => (
            <li key={channel.id}>
              <a
                className="footer__channel"
                href={channel.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`${channel.label} (opens in new tab)`}
              >
                {/* Masked rather than an <img>: the icons are solid black art
                    with no paths to recolour, and a mask lets the glyph take any
                    colour and transition it. The link carries the label. */}
                <span
                  className="footer__channel-icon"
                  style={{ "--icon": `url(${channel.icon})` } as React.CSSProperties}
                />
              </a>
            </li>
          ))}
        </ul>
      </div>
    </footer>
  );
}

export default Footer;
